module.exports = __webpack_public_path__ + "static/img/image_nav_account_arrow@3x(1).8ff61f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_nav_account_arrow@3x(1).png
// module id = 246
// module chunks = 18